export default "__VITE_ASSET__DTplC6T1__"